import React, { Component } from 'react';

import { connect } from 'react-redux';
import config from 'config/api';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Login from 'components/Login';
import Spinner from 'components/Spinner';
import Template from 'components/Template';
// import SectionIntro from './SectionIntro';
// import SectionRecruitment from './SectionRecruitment';
// import SectionRecruit from './SectionRecruit';
// import SectionCompany from './SectionCompany';
// import SectionDemo from './SectionDemo';
// import SectionMore from './SectionMore';
// import SectionUnits from './SectionUnits';
// import SectionTeam from './SectionTeam';
// import SectionEthic from './SectionEthic';
// import SectionAbout from './SectionAbout';
// import SectionContact from './SectionContact';

import { withRouter } from 'react-router-dom';

import { fetchData, getDataHome, getLoadingError } from '../../ducks/asyncFetcher';

const AF_KEY = 'home';
const styles = (theme) => {
  return {
    root: {},
  };
};
class Home extends Component {
  componentDidMount() {
    this.props.onMount();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.$$data === undefined && this.props.$$data) {
      if (this.props.location.hash !== '') {
        window.setTimeout(
          function () {
            const id = this.props.location.hash.replace('#', '');
            const el = document.getElementById(id);
            const top = el
              ? document.getElementById(id).offsetTop + 10 - document.getElementById('header').offsetHeight
              : false;
            // console.log(id, el)
            window.scroll({
              top,
              // behavior: 'smooth'
            });
          }.bind(this),
          50,
        );
      }
    }
  }

  render() {
    const { $$data } = this.props;
    // const $$data = undefined;

    // console.log('DATA', $$data ? $$data.toJS() : false)
    // const { sectionProps } = this.props;
    // const barOffset = ['xs'].indexOf(this.props.width) >= 0 ? 120 : 220;

    // const horizontalOffset = ['xs'].indexOf(this.props.width) >= 0 ? 50 : 58;

    // const sectionProps = {
    //   barOffset,
    //   horizontalOffset,
    // };
    return (
      <Template title={<Typography variant="h1">Connexion</Typography>} fit={true}>
        <div className="home">
          <Choose>
            <When condition={$$data !== undefined}>
              <span></span>
              <Login />
              {/*        <div className={classes.root}>
            <div className={classes.header}>
              <Typography variant="h1">Connexion</Typography>
            </div>
        </div>*/}
            </When>
            <Otherwise>
              <div className={'Loading'}>
                <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
              </div>
            </Otherwise>
          </Choose>
        </div>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

// export default ;
export default withRouter(
  withWidth()(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home))),
);



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx